import React, {useEffect, useMemo, useRef, useState, forwardRef, useImperativeHandle} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Checkbox} from 'antd'
import {LeftOutlined} from '@ant-design/icons';

import './index.less'
import './mobile.less'

import UserInfoForm from '@/components/UserInfoForm'

import {getUsingClassName} from '@/common';
import {addAddressToAddressList, updateAddressItem} from '@/store/modules/address.slice';
import {TOOLKIT_ASYNC_THUNK_REJECTED_KEY} from '@/constants';

const defaultProps = {
  className: '',
  editInfo: null
};

const CartAddressDetail = forwardRef((props, ref) => {
  const options = Object.assign({}, defaultProps, props);
  const dispatch = useDispatch()
  const {t} = useTranslation()

  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'my-address-detail-mobile-container' : 'my-address-detail-container'
  const {userInfo} = commonState
  const {onChange, onPlaceAnOrderClick} = options

  const initialValues = useMemo(() => {
    return {
    }
  }, [])
  
  const userInfoFormRef = useRef(null);
  
  const resetFields = () => userInfoFormRef.current?.resetFields()
  
  const handleAddAddress = (values) => {
    const address = {
      Street: values.address,
      City: values.city,
      State: values.state,
      Zip: values.zipCode,
      Country: userInfo.Country,
      FirstName: values.name, //userInfo.FirstName,
      LastName: userInfo.LastName,
      Telephone: values.phoneNumber, //userInfo.Telephone,
      IsDefault: false,
    };
    dispatch(addAddressToAddressList({address}))
    .then((res) => {
      if (res.meta.requestStatus === TOOLKIT_ASYNC_THUNK_REJECTED_KEY) {
        return
      }
      onChange(res.payload.CustomerDetail_id);
      onPlaceAnOrderClick(res.payload.CustomerDetail_id);
      // resetFields()
    })
  }
  
  useImperativeHandle(ref, () => ({
    runSaveClick: handleSaveClick,
  }));

  const onFormFinish = (values) => {
    return handleAddAddress(values)
  }
  
  const handleSaveClick = () => {
    userInfoFormRef.current?.submit()
  }

  useEffect(() => {
    resetFields()
  }, [initialValues])

  const className = getUsingClassName(
    [rootClassName],
    [options.className]
  )

  return (
    <div className={className}>
      <UserInfoForm
        ref={userInfoFormRef}
        isShowBaseInfo={true}
        isShowEmail={false}
        isShowCompanyInfo={false}
        isShowAddressInfo={true}
        isShowPassword={false}
        onFormFinish={onFormFinish}
        initialValues={initialValues}
      />
    </div>
  )
});

export default CartAddressDetail;
